const hideZeroFloat = n => +n.toString().split('.')?.[ 1 ] === 0 ? n.toString().split('.')[ 0 ] : n;
export default hideZeroFloat;